import { postTrackingData } from "@/api/endpoints/track";
import { SOURCE } from "@/constants";
import { SOURCE_ICON } from "@/mappings/source_icon";
import { EVENT } from "@/tracking_events";
import { ChannelV4, EpisodeV4, MentionCard } from "@/types/MentionCard";
import { useMemo } from "react";

type ExternalChannelLinkProps = {
  channelType: ChannelV4["channel_type"];
  websiteUrl: ChannelV4["website_url"];
  externalId: ChannelV4["external_id"];
  shareUrl: MentionCard["share_url"];
  audioUrl: EpisodeV4["audio_url"];
  channelName: ChannelV4["name"];
};

function getLink(
  channelType: ChannelV4["channel_type"],
  websiteUrl?: ChannelV4["website_url"],
  externalId?: ChannelV4["external_id"]
) {
  if (channelType === SOURCE.YOUTUBE && externalId) {
    return `https://youtube.com/channel/${externalId}`;
  }

  if (channelType === SOURCE.WEB_TV) {
    return externalId;
  }

  return websiteUrl;
}

export default function ExternalChannelLink({
  channelType,
  websiteUrl,
  channelName,
  externalId,
  audioUrl,
  shareUrl,
}: ExternalChannelLinkProps) {
  const SourceIcon = SOURCE_ICON[channelType];

  const url = useMemo(
    () => getLink(channelType, websiteUrl, externalId),
    [channelType, websiteUrl, externalId]
  );

  return (
    <a
      target="_blank"
      data-testid="show-title"
      rel="noopener noreferrer"
      href={url}
      className="flex items-center gap-1.5 link text-violet-500"
      onClick={() => {
        postTrackingData(EVENT.EXTERNAL_URL_CLICK, {
          source: audioUrl,
          context: "show",
          url: shareUrl,
        });
      }}
    >
      {SourceIcon && <SourceIcon className="size-4 stroke-2" />}
      {channelName && <p className="font-medium">{channelName}</p>}
    </a>
  );
}
